import type State from './state';
import type Workflow from './workflow';
import { assertIsInstanceOfArray, assertIsInstanceOfWorkflow } from '../assertions';
import { assertIsInstanceOfState } from './assertions';

interface IStatus {
	readonly state: State;
	readonly states: State[];
	readonly workflow: Workflow;
}

export default class Status implements IStatus {
	public get state(): State {
		return this.#state;
	}

	public get states(): State[] {
		return this.#states;
	}

	public get workflow(): Workflow {
		return this.#workflow;
	}

	#state: State;
	#states: State[];
	#workflow: Workflow;
	public constructor({ state, states, workflow }: IStatus) {
		assertIsInstanceOfState(state);
		this.#state = state;
		assertIsInstanceOfArray(states);
		this.#states = states;
		assertIsInstanceOfWorkflow(workflow);
		this.#workflow = workflow;
	}
}
